import { useQuery } from '@tanstack/react-query';
import { apiGet } from '@/lib/api';
import { useAuth } from '@/lib/auth';
import type { Device, OverviewData } from '@/types';

/** 總覽與小哨共用一份資料；帳號切換時不沿用前一位使用者的統計。 */
export function useSystemOverview() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['system', 'overview', user?.username],
    queryFn: () => apiGet<OverviewData>('/api/v1/system/overview'),
    enabled: Boolean(user),
    refetchInterval: 10_000,
  });
}

/** 小哨報告裡的各裝置狀況，只在報告看得到時才輪詢。
 *  key 以 'devices' 開頭：認領或移除裝置後 invalidate ['devices']，這份也會一起更新。 */
export function useCompanionDevices(enabled: boolean) {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['devices', 'companion', user?.username],
    queryFn: () => apiGet<Device[]>('/api/v1/devices'),
    enabled: Boolean(user) && enabled,
    refetchInterval: 30_000,
  });
}
